import { createLazyFileRoute } from "@tanstack/react-router";

import { EntryPage } from "@/features/accession/routes/EntryNew";

export const Route = createLazyFileRoute("/_auth/_app/accessions/new")({
  component: EntryPage,
});
